<template>
  <div class="base-loading-component app-flex-row-center">
    <div class="wrapper" :style="{ transform: `scale(${scale})` }">
      <div
        v-for="(item, index) in lineNumber"
        :key="index"
        class="line"
        :style="lineStyle(index)"
      ></div>
    </div>
    <span
      v-show="textVisible"
      :class="textClass"
      :style="{ color }"
      class="font-14 text"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    lineNumber: { type: Number, default: 12 },
    delay: { type: Number, default: 0.1 },
    color: { type: String, default: '#8e9091' },
    scale: { type: Number, default: 0.4 },
    text: { type: String, default: '加载中' },
    textVisible: { type: Boolean, default: true },
    textClass: { type: String, default: '' }
  },
  methods: {
    lineStyle(i) {
      const rotate = (360 / this.lineNumber) * i
      const delay = this.delay * i
      const animationDuration = (this.delay * this.lineNumber).toFixed()
      const opacity = i > 0 ? 1 - 0.0625 * (i + 1) : 1
      return {
        transform: `rotate(${rotate}deg) translate(0, -17px)`,
        animationDuration: `${animationDuration}s`,
        animationDelay: `${delay}s`,
        backgroundColor: this.color,
        opacity: `${opacity}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-loading-component {
  align-items: center;
  @keyframes loading {
    from {
      opacity: 1;
    }
    to {
      opacity: 0.25;
    }
  }
  .wrapper {
    position: relative;
    width: 52px;
    height: 52px;
    .line {
      width: 3px;
      height: 9px;
      border-radius: 9px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -4.5px;
      margin-left: -1.5px;
      animation: loading linear infinite;
    }
  }
}
</style>
